import type { OrderDetails } from '@/entities/order/model'
import { useLocation, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

/**
 * Hook for navigating to order details from any order card component
 * Uses search params to show order details in a modal while keeping the parent route visible
 *
 * @returns A function that appends the orderId to the current URL
 */
export function useOrderDetailsNavigation() {
  const navigate = useNavigate()
  const location = useLocation()

  const navigateToOrderDetails = useCallback((orderId: OrderDetails['orderId'], additionalParams?: Record<string, string | boolean>) => {
    // Convert boolean values to strings for URL parameters
    const stringParams = additionalParams ? Object.fromEntries(
      Object.entries(additionalParams).map(([key, value]) => [key, String(value)]),
    ) : undefined

    navigate({
      to: location.pathname,
      search: { orderId, ...stringParams },
      resetScroll: false,
    })
  }, [navigate, location.pathname])

  return navigateToOrderDetails
}
